import React from "react";

import { SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { withVar } from "themes/helpers";

interface IProps {
  children: React.ReactNode;
  center?: boolean;
}

const ContentWrapper: React.FC<IProps & IWithBreakpointsProps> = ({ children, center, isMobile }) => (
  <Flex justifyContent={center ? "center" : "flex-start"}>
    <Flex
      paddingH={withVar(isMobile ? SpacingToken.Spacing2 : SpacingToken.Spacing16)}
      paddingTop={withVar(SpacingToken.Spacing9)}
      column
      gap={withVar(center ? SpacingToken.Spacing10 : SpacingToken.Spacing9)}
      alignItems={center ? "center" : "initial"}
      marginBottom={withVar(SpacingToken.Spacing8)}
      width="100%"
      maxWidth={center ? "800px" : "initial"}
    >
      {children}
    </Flex>
  </Flex>
);
export default withBreakpoints(ContentWrapper);
